var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomers2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9984 5.96651C14.9484 5.95817 14.8901 5.95817 14.8401 5.96651C13.6901 5.92484 12.7734 4.98317 12.7734 3.81651C12.7734 2.62484 13.7318 1.6665 14.9234 1.6665C16.1151 1.6665 17.0734 2.63317 17.0734 3.81651C17.0651 4.98317 16.1484 5.92484 14.9984 5.96651Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1383 12.0333C15.28 12.225 16.5383 12.025 17.4216 11.4333C18.5966 10.65 18.5966 9.36664 17.4216 8.58331C16.53 7.99164 15.2549 7.79163 14.1133 7.99163",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97344 5.96651C5.02344 5.95817 5.08177 5.95817 5.13177 5.96651C6.28177 5.92484 7.19844 4.98317 7.19844 3.81651C7.19844 2.62484 6.24011 1.6665 5.04844 1.6665C3.85677 1.6665 2.89844 2.63317 2.89844 3.81651C2.90677 4.98317 3.82344 5.92484 4.97344 5.96651Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83255 12.0333C4.69088 12.225 3.43255 12.025 2.54922 11.4333C1.37422 10.65 1.37422 9.36664 2.54922 8.58331C3.44089 7.99164 4.71588 7.79163 5.85755 7.99163",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0023 12.1916C9.95234 12.1833 9.89401 12.1833 9.84401 12.1916C8.69401 12.1499 7.77734 11.2083 7.77734 10.0416C7.77734 8.84994 8.73568 7.8916 9.92734 7.8916C11.119 7.8916 12.0773 8.85827 12.0773 10.0416C12.069 11.2083 11.1523 12.1583 10.0023 12.1916Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57656 14.8168C6.40156 15.6001 6.40156 16.8835 7.57656 17.6668C8.9099 18.5585 11.0932 18.5585 12.4266 17.6668C13.6016 16.8835 13.6016 15.6001 12.4266 14.8168C11.1016 13.9335 8.9099 13.9335 7.57656 14.8168Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers2);
export default __webpack_public_path__ + "static/media/customers2.7fb6248c18cb7d3b848c0f468fab4eaa.svg";
export { ForwardRef as ReactComponent };